import axios from 'axios';
import { MaterialDTO } from '../dto/MaterialDTO';
import { routePrefix } from '../app/App';

export async function getMaterials(query: string): Promise<MaterialDTO[]> {
  const url =  `${routePrefix()}materials${query}`;
  const { data } = await axios.get<MaterialDTO[]>(url);
  return data;
}